import { render, staticRenderFns } from "./departure-calendar.vue?vue&type=template&id=6f2a4b98"
import script from "./departure-calendar.vue?vue&type=script&lang=js"
export * from "./departure-calendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports